import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
  },

  mutations: {
  },
  actions: {
    // 消息分页
    async messagePageList ({ commit }, params) {
      const response = await axios.post('/message/v1/page', params)
      return response.data
    },

    // 消息详情
    async messageDetail ({ commit }, params) {
      const response = await axios.get(`/message/v1/${params.recordNo}/detail`)
      return response.data
    },

    // 消息已读
    async messageRead ({ commit }, params) {
      const response = await axios.get(`/message/v1/${params.recordNo}/read`)
      return response.data
    },

    // 消息确认
    async messageConfirm ({ commit }, params) {
      const response = await axios.post(`/message/v1/${params.recordNo}/confirm`, params)
      return response.data
    },

    // 发送短信
    async messageSendSms ({ commit }, params) {
      const response = await axios.get(`/message/v1/${params.recordNo}/send-sms`, params)
      return response.data
    }    

  }
}
